export default {
	name: 'NoMoreData'
};